"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReferenceFieldValue = void 0;
function isReferenceFieldValue(value) {
    return Array.isArray(value);
}
exports.isReferenceFieldValue = isReferenceFieldValue;
